<template>
  <div class="help">
    <div id="nav" class="header">
      <head-top></head-top>
    </div>
    <div class="about-main">
      <div class="about-left">
        <div class="help-tab">
          <div class="about-title">帮助中心</div>
          <div
            class="about-item"
            v-for="(item, index) in helpList"
            :key="index"
            :class="{selected:item.isSelected}"
            @click="helpTab(item)"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="about-right">
        <div v-for="(item, index) in helpList" :key="index">
          <div v-if="item.isSelected">
            <div class="title-default">{{item.title}}</div>
            <div style="padding: 0 30px;">
              <span v-html="item.content"></span>
            </div>
            <!-- <div
              class="about-content"
            >猫大师作为专业从事家居服务的行业O2O平台，致力于提供家居配送、安装、维修、保养等一站式服务，解决家居售后环节成本高、服务质量差、管理难度大等棘手问题。猫大师创世团队前身已拥有多年家居配送、安装服务相关经验，已和数千名安装师傅达成合作关系，服务范围覆盖国内多座城市。猫大师平台深度结合微信连接能力，实现线上下单、抢单、支付、资金托管、评价等功能，极大程度提升效率的同时也推进了行业标准、诚信机制的建立。客户通过猫大师下单后可以自主选择师傅确定报价并全程掌握订单服务情况，师傅通过实名认证和培训之后即可通过平台接单获得收益，过程中消费者可以享受到更有品质的服务，实现了多方共赢。</div>
            <div
              class="about-content"
            >猫大师是一家以技术为成长驱动的公司，从成立伊始，就投入大量资源开发完善可靠、能够不断升级、以应用服务为核心的自有技术平台，从而驱动家居服务能力的提升。未来猫大师将会发展大数据、人工智能、AR/VR、智能硬件等最新技术，以推动家居服务行业更大的变革。</div>
            <img src="../../assets/img/logo.png" alt />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
export default {
  components: {
    headTop
  },
  data() {
    return {
      helpList: [
        { name: "怎么取消订单", isSelected: true },
        { name: "怎么联系卖家", isSelected: false },
        { name: "怎么退款", isSelected: false },
        { name: "资金问题", isSelected: false },
        { name: "物流问题", isSelected: false }
      ]
    };
  },
  mounted() {
    this.getHelp();
  },
  methods: {
    helpTab(item) {
      for (let i of this.helpList) {
        i.isSelected = false;
      }
      item.isSelected = true;
    },
    // 获取帮助中心
    getHelp() {
      let _this = this;
      this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=50&typeCode=help`
      ).then(res => {
        if (res.code == 0) {
          res.data.pageList.map(i => {
            i.isSelected = false;
          });
          _this.helpList = res.data.pageList;
          if (JSON.stringify(_this.$route.params) == "{}") {
            _this.helpList[0].isSelected = true;
          } else {
            _this.helpList.map(i => {
              if (i.title == _this.$route.params.title) {
                i.isSelected = true;
              }
            });
          }
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.help {
  .headDefault {
    background: #3455d3;
  }
  .help-tab {
    background: #ffffff;
    padding-bottom: 30px;
  }
  .about-right {
    background: #ffffff;
  }
  .title-default {
    font-weight: bold;
    color: #2f3133;
    font-size: 16px;
    height: 80px;
    padding: 32px 30px;
  }
  .help_tab {
    border-bottom: 2px solid #ffffff;
  }
}
</style>
<style lang="scss" scoped>
.about-content {
  padding: 0 30px;
  font-size: 12px;
  color: rgba(94, 96, 102, 1);
  line-height: 24px;
  margin-bottom: 20px;
}
img {
  width: 463px;
  margin-left: 30px;
  margin-bottom: 50px;
}
</style>